import type {
  VideoAutoplayAction,
  VideoAutoplayState,
  VideoMeta
} from './types';

export const initialState: VideoAutoplayState = {
  videos: new Map<string, VideoMeta>(),
  chosenVideoIds: new Set<string>(),
  hoveredVideoId: null
};

export function videoAutoplayReducer(
  state: VideoAutoplayState,
  action: VideoAutoplayAction
): VideoAutoplayState {
  switch (action.type) {
    case 'REGISTER': {
      const newVideos = new Map(state.videos);

      newVideos.set(action.meta.id, action.meta);

      return { ...state, videos: newVideos };
    }

    case 'UNREGISTER': {
      const newVideos = new Map(state.videos);
      const newChosenVideoIds = new Set(state.chosenVideoIds);

      newVideos.delete(action.id);
      newChosenVideoIds.delete(action.id);

      return {
        ...state,
        videos: newVideos,
        chosenVideoIds: newChosenVideoIds,
        hoveredVideoId:
          state.hoveredVideoId === action.id ? null : state.hoveredVideoId
      };
    }

    case 'UPDATE_VISIBILITY': {
      const meta = state.videos.get(action.id);

      if (!meta) {
        return state;
      }

      const newVideos = new Map(state.videos);
      newVideos.set(action.id, { ...meta, visibility: action.visibility });

      return { ...state, videos: newVideos };
    }

    case 'SET_HOVERED':
      return { ...state, hoveredVideoId: action.id };

    case 'UPDATE_CHOSEN_VIDEOS':
      return { ...state, chosenVideoIds: new Set(action.ids) };

    case 'MARK_AS_CALCULATED': {
      const meta = state.videos.get(action.id);

      if (!meta) {
        return state;
      }

      const newVideos = new Map(state.videos);
      newVideos.set(action.id, { ...meta, wasCalculated: true });

      return { ...state, videos: newVideos };
    }

    default:
      return state;
  }
}
